import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from "@angular/router";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { MatToolbar, MatToolbarModule } from "@angular/material/toolbar";

@Component({
  selector: "app-cyclinder-listings",
  templateUrl: "./cyclinder-listings.component.html",
  styleUrls: ["./cyclinder-listings.component.scss"],
  standalone: true,
  imports: [CommonModule, MatToolbar, MatToolbarModule],
})
export class CyclinderListingsComponent implements OnInit {
  public cylinderBaseUrl = BaseUrlConstantsService.CYLINDER_BASE_URL;
  @Input("tabName") tabName: string = "Cylinders";
  @Input("tab1") tab1: boolean = true;
  @Input("tab2") tab2: boolean;
  @Input("tab3") tab3: boolean;
  @Input("tab4") tab4: boolean;
  @Input("tab5") tab5: boolean;
  @Input("tab7") tab7: boolean;
  public production = BaseUrlConstantsService.PRODUCTION_KEY;
  public qa = BaseUrlConstantsService.QA_KEY;
  // cylinders: Cylinder[] = [
  cylinders = [
    {
      id: "S12345-CYL-00001",
      name: "Cylinder 1",
      status: "healthy",
      equipmentType: "Driven Equipment",
    },
    {
      id: "S12345-CYL-00002",
      name: "Cylinder 2",
      status: "warning",
      equipmentType: "Driven Equipment",
    },
    {
      id: "S12345-CYL-00003",
      name: "Cylinder 3",
      status: "out-for-service",
      equipmentType: "Driven Equipment",
    },
    {
      id: "S12345-CYL-00004",
      name: "Cylinder 4",
      status: "healthy",
      equipmentType: "Driven Equipment",
    },
    {
      id: "S12345-CYL-00005",
      name: "Cylinder P-234",
      status: "offline",
      equipmentType: "Driven Equipment",
    },
    {
      id: "S12345-CYL-00006",
      name: "Cylinder A-100",
      status: "healthy",
      equipmentType: "Driven Equipment",
    },
    {
      id: "S12345-CYL-00007",
      name: "Cylinder B-455",
      status: "healthy",
      equipmentType: "Driven Equipment",
    },
    {
      id: "S12345-CYL-00008",
      name: "Cylinder Z-900",
      status: "warning",
      equipmentType: "Driven Equipment",
    },
  ];

  sites = [];
  applications = [];
  filteredApplications = [];
  filteredCylinders = [];
  allCylinders = {};
  selectedSite = 0;
  selectedApp = 0;
  // client_id = this.production ? "388" : this.qa ? "44" : "361";
  client_id = localStorage.getItem('role')=='ADMIN'?localStorage.getItem("admin_client_id"):localStorage.getItem("user_id")
  constructor(private router: Router, private srv: BackendApiService) {}

  ngOnInit(): void {
    this.fetchSitesAppAndProducts();
  }

  openCyclinderDashboard(cylinder:any) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        tab1: true,
        tab2: this.tab2,
        tab3: this.tab3,
        tab4: this.tab4,
        tab5: true,
        tab7: this.tab7,
        tabName: "tab-5",
        client_id: cylinder.user_id,
        subsystem_id: cylinder.subsystem_id,
        asset_id: cylinder.asset_id,
        device_id: cylinder.device_id,
        mac_address: cylinder.mac_address,
        site_name: cylinder.site_name,
        application_name: cylinder.app_name,
        cylinder_name: cylinder.device_sno,
        // client_id: this.production ? "4" : this.qa ? "41" : "2",
        // asset_id: this.production ? "3804" : this.qa ? "210" : "1014",
        // device_id: this.production ? "514" : this.qa ? "69" : "214",
        // mac_address: this.production
        //   ? "E0693A043C4E"
        //   : this.qa
        //   ? "E0693A0425D2"
        //   : "E0693A043C4E",
      },
    };
    this.router.navigate(["cyclinder-dasboard"], navigationExtras);
  }

  getStatusClass(status: string): string {
    switch (status) {
      case "healthy":
        return "status-healthy";
      case "warning":
        return "status-warning";
      case "offline":
        return "status-offline";
      case "error":
      case "out-for-service":
        return "status-error";
      default:
        return "status-healthy";
    }
  }

  async fetchSitesAppAndProducts() {
    try {
      const response: any = await this.srv.getDataV2(
        // `http://localhost:7778/cylinder/sites-app/${this.client_id}/5`
        `${this.cylinderBaseUrl}/cylinder/sites-app/${this.client_id}/5`
      );
      if (response && response.code === 200) {
        const { applications, sites, products } = response.body;
        this.applications = applications;
        this.sites = sites;
        this.allCylinders = products;
        this.filteredCylinders = Object.values(products).flatMap((apps) =>
          Object.values(apps).flat()
        );
      } else {
        console.log("Error", response);
      }
    } catch (error) {}
  }

  onSiteSelected(value) {
    this.selectedSite = value;

    if (this.selectedSite == 0) {
      // REST TO ALL CYLINDERS AND SELECT ALL APPLICATIONS AND ALL SITES
      this.filteredCylinders = Object.values(this.allCylinders).flatMap(
        (apps) => Object.values(apps).flat()
      );
    } else {
      // WE SELECTED A SITE
      this.filteredApplications = this.applications.filter(
        (app) => app.site_id == value
      );
      if (this.allCylinders[value] == undefined) {
        this.filteredCylinders = [];
        return;
      }
      this.filteredCylinders = Object.values(this.allCylinders[value]);
      this.filteredCylinders = Object.values(this.allCylinders[value]).flat();
    }
  }
  onAppSelected(value) {
    this.selectedApp = value;
    if (this.selectedSite != 0 && this.selectedApp != 0) {
      if (this.allCylinders[this.selectedSite][value] == undefined) {
        this.filteredCylinders = [];
        return;
      }
      this.filteredCylinders = this.allCylinders[this.selectedSite][value];
    }
  }
}
